import { createContext, useState, useContext, useRef } from 'react'
import { useAuthContext } from './authContext'

const UnreadMessagesContext = createContext()
const UnreadMessagesProvider = ({ children }) => {
  const { getUser } = useAuthContext()
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false)
  const seenMessagesRef = useRef({})

  const userReceivedUnreadMessages = (conversationId, recentMessageId) => {
    setHasUnreadMessages(true)
    removeSeenMessage(conversationId, recentMessageId)
  }

  const userReadMessages = () => {
    setHasUnreadMessages(false)
  }

  const isMessageSeen = (conversationId, recentMessage) => {
    return (
      // Message is considered seen if it is our own
      recentMessage?.userUuid === getUser()?.nearbyUuid ||
      // Message is considered seen if the user viewed the message in Messages modal
      !!recentMessage?.seenAt ||
      // Message is seen if user viewed it in the conversation screen after receiving
      (recentMessage && seenMessagesRef.current[conversationId] === recentMessage?.uuid)
    )
  }

  const addSeenMessage = (conversationId, recentMessageId) => {
    seenMessagesRef.current[conversationId] = recentMessageId
  }

  const removeSeenMessage = (conversationId) => {
    seenMessagesRef.current[conversationId] = null
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // const { authenticated } = useAuthContext()
  // const [unreadMessages, setUnreadMessages] = useState(new Set())

  // useEffect(() => {
  //   if (authenticated) {
  //     axios.get(`api/my/conversations/unread_messages`)
  //       .then((res) => {
  //         const newUnreadMessages = new Set()
  //         res?.data?.forEach((userId) => newUnreadMessages.add(userId))
  //         setUnreadMessages(newUnreadMessages)
  //       })
  //       .catch(console.log)
  //   }
  // }, [authenticated])

  // const removeUnreadMessage = (userId) => {
  //   unreadMessages.delete(userId)
  //   setUnreadMessages(new Set(unreadMessages))
  // }

  // const addUnreadMessage = (userId) => {
  //   unreadMessages.add(userId)
  //   setUnreadMessages(new Set(unreadMessages))
  // }

  return (
    <UnreadMessagesContext.Provider value={{
      // unreadMessages,
      // removeUnreadMessage,
      // addUnreadMessage,
      //////////////////////////////////////
      hasUnreadMessages,
      userReceivedUnreadMessages,
      userReadMessages,
      isMessageSeen,
      addSeenMessage,
      removeSeenMessage,
    }}>
      {children}
    </UnreadMessagesContext.Provider>
  )
}

const useUnreadMessagesContext = () => useContext(UnreadMessagesContext)

export default useUnreadMessagesContext

export { UnreadMessagesContext, UnreadMessagesProvider, useUnreadMessagesContext }
